import config from "@sg-protect/runtime-config";
import { InternalServerError, type ModuleRegisterFunction } from "@sg-protect/shell";
import { Outlet } from "react-router";
import { msalManagementInstance } from "./api/auth/msalManagement.ts";
import { injectMockMsal } from "./api/mocks/msal.mock.tsx";
import { AuthenticatedProviders } from "./components/layout/AuthenticatedProviders.tsx";
import { GlobalProviders } from "./components/layout/GlobalProviders.tsx";
import { ArchivesRoutes } from "./constants.ts";
import { privateRoutes } from "./routes.tsx";

const registerRoutes: ModuleRegisterFunction = runtime => {
    runtime.registerRoute({
        path: ArchivesRoutes.registration.root,
        element: (
            <GlobalProviders>
                <Outlet />
            </GlobalProviders>
        ),
        errorElement: <InternalServerError homeUrl={config.get().home.baseUrl} />,
        children: [
            {
                element: (
                    <AuthenticatedProviders>
                        <Outlet />
                    </AuthenticatedProviders>
                ),
                children: privateRoutes
            }
        ]
    });
};

const registerMsw: ModuleRegisterFunction = async runtime => {
    if (runtime.isMswEnabled) {
        const requestHandlers = (await import("./api/msw.ts")).handlers;

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        requestHandlers.forEach(handler => Object.assign(handler, { mockModule: "archives" }));

        runtime.registerRequestHandlers(requestHandlers);
        injectMockMsal(msalManagementInstance);
    }
};

export const register: ModuleRegisterFunction = async runtime => {
    await registerMsw(runtime);

    await registerRoutes(runtime);
};
